import { Card, CardContent } from "@/components/ui/card";
import { SectionTitle } from "@/components/common/SectionTitle";
import { useLanguage } from "@/context/LanguageContext";
import { getSiteContent } from "@/data/siteContent";

export default function ProjectsPage() {
  const { language, isArabic } = useLanguage();
  const content = getSiteContent(language);

  return (
    <section className="py-16 md:py-24" data-testid="projects-page">
      <div className="container mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <SectionTitle
          badge={isArabic ? "أعمالنا" : "Our Work"}
          title={content.projects.title}
          description={content.projects.subtitle}
          testIdPrefix="projects-main"
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-testid="projects-sectors-grid">
          {content.sectors.map((sector, index) => {
            const Icon = sector.icon;
            const title = isArabic ? sector.titleAr : sector.titleEn;
            const description = isArabic ? sector.descriptionAr : sector.descriptionEn;

            return (
              <Card key={sector.key} className="overflow-hidden border-slate-200" data-testid={`sector-card-${sector.key}`}>
                <img src={sector.image} alt={title} className="h-52 w-full object-cover" data-testid={`sector-image-${sector.key}`} />
                <CardContent className="space-y-3 p-5">
                  <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-secondary/15 text-secondary" data-testid={`sector-icon-wrap-${sector.key}`}>
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900" data-testid={`sector-title-${sector.key}`}>
                    {title}
                  </h3>
                  <p className="text-sm text-slate-600" data-testid={`sector-description-${sector.key}`}>
                    {description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-10 rounded-3xl bg-slate-900 p-6 md:p-8" data-testid="projects-process-block">
          <h3 className="mb-5 text-2xl font-bold text-white" data-testid="projects-process-heading">
            {content.projects.processTitle}
          </h3>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3" data-testid="projects-process-steps-grid">
            {content.projects.processSteps.map((step, idx) => (
              <div key={step} className="rounded-xl bg-white/10 p-4" data-testid={`projects-process-step-card-${idx}`}>
                <p className="mb-2 text-sm text-secondary" data-testid={`projects-process-step-number-${idx}`}>
                  {isArabic ? `الخطوة ${idx + 1}` : `Step ${idx + 1}`}
                </p>
                <p className="text-sm text-slate-100" data-testid={`projects-process-step-text-${idx}`}>
                  {step}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
